"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ad = exports.GOOGLE_STOCK_STATUS = exports.AD_TYPES = exports.AD_VENDORS = void 0;
const Common_1 = require("./Common");
const Base_1 = require("./Base");
const index_1 = require("../index");
var AD_VENDORS;
(function (AD_VENDORS) {
    AD_VENDORS["google"] = "google";
    AD_VENDORS["bing"] = "bing";
    AD_VENDORS["facebook"] = "facebook";
})(AD_VENDORS || (exports.AD_VENDORS = AD_VENDORS = {}));
var AD_TYPES;
(function (AD_TYPES) {
    AD_TYPES["product"] = "product";
    AD_TYPES["search"] = "search";
    AD_TYPES["remarketing"] = "remarketing";
})(AD_TYPES || (exports.AD_TYPES = AD_TYPES = {}));
var GOOGLE_STOCK_STATUS;
(function (GOOGLE_STOCK_STATUS) {
    GOOGLE_STOCK_STATUS["In_Stock"] = "in_stock";
    GOOGLE_STOCK_STATUS["Out_Of_Stock"] = "out_of_stock";
    GOOGLE_STOCK_STATUS["Pre_Order"] = "preorder";
    GOOGLE_STOCK_STATUS["Back_Order"] = "backorder";
})(GOOGLE_STOCK_STATUS || (exports.GOOGLE_STOCK_STATUS = GOOGLE_STOCK_STATUS = {}));
class Ad extends Base_1.Base {
    title = '';
    description = '';
    type = null;
    vendor = null;
    vendor_id = '';
    url = '';
    image = '';
    images = [];
    weight = null;
    brand = '';
    category = '';
    price = null;
    dynamic_price = null;
    stock = GOOGLE_STOCK_STATUS.In_Stock;
    product = null;
    old_id = '';
    published = [];
    constructor(data, olMap) {
        super('ads', 30);
        (0, Common_1.setObjectProperties)(this, data, olMap, Ad);
    }
    getGoogleProductAdLine(domain, firstLine) {
        let line = 'id\ttitle\tlink\timage link\tdescription\tprice\tshipping weight\tbrand\tavailability\tMPN\tproduct_type\n';
        if (!firstLine) {
            let image = (this.image.match(/^http/)) ? this.image : `${domain}${this.image}`;
            let url = (this.url.match(/^http/)) ? this.url : `${domain}${this.url}`;
            if (!url.match(/\?/)) {
                url += `?adid=${this.id}`;
            }
            line = `${this.vendor_id}\t${this.title}\t${url}\t${image}\t${this.description.replace(/\n/g, '')}\t${this.price} USD\t${this.weight} lb\t${this.brand}\t${this.stock}\t${this.vendor_id}\t${this.category}\n`;
        }
        return line;
    }
    toString() {
        return `Ad: ${this.vendor}: ${this.title}`;
    }
    toJSON() {
        let r = super.toJSON();
        r.product = this.product?.toJSON ? this.product.toJSON() : this.product;
        return r;
    }
}
exports.Ad = Ad;
index_1.olm.ads = (ref, map) => {
    return new Ad(ref, map);
};
